import DualColorMapLegend from "components/ColorMapLegend/DualColorMapLegend";
import { observer } from "mobx-react-lite";
import { getDualRadarGradientColormap } from "stores/data/RadarMap/RadarColormap";
import { useTranslation } from "react-i18next";

const RadarColorMap: React.FC = () => {
  const dualColormap = getDualRadarGradientColormap();
  const { i18n } = useTranslation();

  return (
    <DualColorMapLegend
      rainGradient={dualColormap.rain.gradient}
      snowGradient={dualColormap.snow.gradient}
      rainLabel={dualColormap.rain.label}
      snowLabel={dualColormap.snow.label}
      rainScaleLabels={dualColormap.rain.scaleLabels}
      rainMmhLabels={dualColormap.rain.mmhLabels}
      key={`${i18n.language}`}
    />
  );
};

export default observer(RadarColorMap);
